import { HttpsCallable } from 'firebase/functions';
import type {
  DocumentData,
  FirestoreDataConverter,
  PartialWithFieldValue,
  QueryDocumentSnapshot,
} from 'firebase-admin/firestore';

import {
  firebaseCallable,
  firebaseFunctions,
} from '@/src/modules/auth/auth.config';
import {
  capitalizeFirstLetter,
  decapitalizeFirstLetter,
} from '@/src/utils/format/string';

const getFunction = <RequestType, ResponseType>(
  domain: string,
  entity: string,
  action: string
): HttpsCallable<RequestType, ResponseType> => {
  const funcName = `${domain}-${decapitalizeFirstLetter(
    entity
  )}${capitalizeFirstLetter(action)}`;

  return firebaseCallable(firebaseFunctions, funcName);
};

export const callFirebaseFunction = async <RequestType, ResponseType>(
  domain: string,
  entity: string,
  action: string,
  body: RequestType
): Promise<ResponseType | null> => {
  const func = getFunction<RequestType, ResponseType>(domain, entity, action);

  try {
    const result = await func(body);
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export function makeFirestoreDataConverter<T>(): FirestoreDataConverter<T> {
  return {
    toFirestore: (data: PartialWithFieldValue<T>) => data as DocumentData,
    fromFirestore: (snapshot: QueryDocumentSnapshot) => snapshot.data() as T,
  };
}
